import { createSimplePersistentQuery } from "@/hooks/use-api-query";
import { get } from "@/libs/http";
import { VipCustomerServiceCheckRes } from '@/types/api/message/vip-customer-service-check.d';

export const getVipUrl = () => get<VipCustomerServiceCheckRes>('/message/v1/vip_customer_service/check');

export const useGetVipUrl = createSimplePersistentQuery(
  getVipUrl,
  ['vip-url'],
  {
    persist: true,
    persistKey: 'vip-url',
    staleTime: 10 * 1000, // 30 秒内数据视为新鲜，不会重复请求
  }
);